import { Injectable } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { WorkOrderCardInterface } from '../app/interface/work-order-card';
import { CognitoUtil } from './cognito.service';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from 'services/error.service';
import { of, throwError } from 'rxjs';
import { YonyxGuideInterface } from 'app/interface/yonyxGuige';
import { YonyxGuide } from 'app/models/yonyx-guide';
import { WorkOrderCreate } from 'app/models/work-order-create';
import { WorkOrderCard } from 'app/models/work-order';
import { WorkOrderFieldService } from 'app/models/work-order-field-service';

@Injectable()
export class WorkOrderService {
  constructor(private http: HttpClient, private router: Router, private cognitoUtil: CognitoUtil, private errorService: ErrorService) { }

  TRIPOD_HRA_API = 'tripodHraApi'
  API_GW = 'apiGateway'

  getHeaders(type) {
    this.cognitoUtil.refresh();
    if (type === this.API_GW) {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('AccessToken')
        })
      };
    } else if (type === this.TRIPOD_HRA_API) {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('AWSCreds'),
          'Identity': localStorage.getItem('CognitoId'),
          'Sub': localStorage.getItem('CognitoSub')
        })
      };
    }
  }

  getYonyxGuides() {
    return this.http.get<YonyxGuideInterface[]>(environment.apiEndPoint + 'workorder/yonyxguides', this.getHeaders(this.TRIPOD_HRA_API))
      .pipe(
        map((response) => <YonyxGuide[]>(response)),
        catchError(err => throwError(this.handleError(err)))
      );
  }

  saveRetry(workOrder: WorkOrderCreate) {
    return this.http.post(environment.apiEndPoint + 'workorder/saveretry', workOrder, this.getHeaders(this.TRIPOD_HRA_API))
      .pipe(
        response => (response),
        err => (err)
      );
  }

  createWorkOrder(projectGuid: string, grantPte: boolean) {
    return this.http.post(`${environment.apiEndPoint}workorder/create?projectGuid=${projectGuid}&grantPte=${grantPte}`, null, this.getHeaders(this.TRIPOD_HRA_API))
      .pipe(
        map(response => (response)),
        map(err => (err))
      );
  }

  getAllWorkOrders() {
    return this.http.get<WorkOrderCardInterface[]>(`${environment.apiEndPoint}workorder/GetAllWorkOrdersForDashboard?accessToken=${localStorage.getItem('AccessToken')}`, this.getHeaders(this.TRIPOD_HRA_API))
      .pipe(
        map((response) => response.map(i =>
          new WorkOrderCard(i.Id,
            i.BriefDescription,
            i.CreatedDate ? new Date(i.CreatedDate) : undefined,
            i.ScheduledDate ? new Date(i.ScheduledDate) : undefined,
            i.Designation,
            i.Status,
            i.Assignment,
            i.Category,
            i.Phone,
            i.NumericPhone,
            false,
            i.DisplayId)
        )
        ),
        catchError(err => throwError(this.handleError(err)))
      );
  }

  handleError(error: HttpErrorResponse | any) {
    let errMsg: string;
    if (error.status == 400) {
      errMsg = 'Bad Request';
    } else if (error.status == 401) {
      errMsg = 'Not Authorized';
    } else if (error.status === 403) {
      errMsg = 'Forbidden';
      this.router.navigate(['/logout']);
    } else if (error.status == 500) {
      errMsg = 'Internal Server error'
    } else {
      errMsg = 'Unknown error. Contact support.';
    }
    return errMsg;
  }

  canCreateWorkOrder() {
    return this.http.get(`${environment.apiEndPoint}workorder/cancreate`, this.getHeaders(this.TRIPOD_HRA_API))
      .pipe(
        response => response,
        err => err
      );
  }
}